<template>
  <div class="search-result__inner">
    <div class="search-result__taxonomy">
      <div class="badge">{{getFieldValue(result.Fields, 'StudyType')}} postgraduate programme</div>
    </div>
    <div class="search-result__main">
      <h1>{{ getFieldValue(result.Fields, 'Title') }}</h1>
      <p
        v-html="getFieldValue(result.Fields, 'Description', 'Unknown', true)"
      ></p>
    </div>
    <div class="search-result__meta">
      <dl>
        <dt>Modes of study</dt>
        <dd>
          {{ capitalise(getFieldValue(result.Fields, 'StudyModes')) }}
        </dd>
        <dt>Awards available</dt>
        <dd>
          {{ capitalise(getFieldValue(result.Fields, 'CourseAwards')) }}
        </dd>
        <dt>Delivery method</dt>
        <dd>
          {{ getDeliveryMethodValue ?? 'Not applicable' }}
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchResult',
  props: {
    result: {
      type: Object,
      required: true,
    },
  },
  computed: {
    
    isNewCourse() {
      return this.getFieldValue(this.result.Fields, 'NewCourse') === 'Yes'
        ? true
        : false;
    },

    getDeliveryMethodValue() {
      const value = this.getFieldValue(this.result.Fields, 'StudyDeliveryMethod')
        .replace(/(^\w|\s\w)/g, m => m.toUpperCase())
        .replaceAll('-', ' ')
        .replaceAll('On campus', 'On-campus')
        .replaceAll('Online with on campus learning', 'Online with on-campus elements')
        .replaceAll('&', 'or');      
      return value;
    },
  },
  methods: {
    getFieldValue(
      fields,
      fieldName,
      defaultValue = undefined,
      returnHighlights = false
    ) {
      // Assign field to a constant
      const field = fields[fieldName];
      // Verify that the field exists
      if (field) {
        // Assign field value to variable so it can be trimmed
        let fieldValue = field.Value;
        // Initialise field higlights with trimmed field value
        let fieldHighlights = fieldValue;
        // Verify that highlights exist on this field
        if (field.Highlights && field.Highlights.length > 0) {
          // Update field higlights to the first highlight only
          fieldHighlights = field.Highlights.join(' ');
        }
        // Return trimmed field value or joined highlights
        return returnHighlights ? fieldHighlights : fieldValue;
      }
      // The field does not exist, return the default string
      return defaultValue;
    },
    capitalise(string = '') {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    getYears(yearLength) {
      return `${yearLength} year${yearLength !== 1 ? 's' : ''}`;
    },
  },
};
</script>

<style></style>
